import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage.tsx';
import GameRoom from './components/GameRoom.tsx';
import JoinRoom from './components/JoinRoom.tsx';

function App() {
    return (
        <Router>
            <div className="min-h-screen bg-wordle-dark">
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/join" element={<JoinRoom />} />
                    <Route path="/room/:roomId" element={<GameRoom />} />
                </Routes>
            </div>
        </Router>
    );
}

export default App;